import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'App.ApplicationProfile.SelectFloorPlanModal.Title',
    defaultMessage: 'Select Floor Plan',
  },
  instruction: {
    id: 'App.ApplicationProfile.SelectFloorPlanModal.Instruction',
    defaultMessage:
      'Select a floorplan to be used for qualifying this applicant for affordable housing.',
  },
  warning: {
    id: 'App.ApplicationProfile.SelectFloorPlanModal.Warning',
    defaultMessage:
      'Saving clears the calculated assistance, the qualification test results ' +
      'and any manual qualification override. The household information you ' +
      'have entered is kept.',
  },
  floorPlan: {
    id: 'App.ApplicationProfile.SelectFloorPlanModal.FloorPlan',
    defaultMessage: 'Floor Plan',
  },
  cancel: {
    id: 'App.ApplicationProfile.SelectFloorPlanModal.Cancel',
    defaultMessage: 'Cancel',
  },
  save: {
    id: 'App.ApplicationProfile.SelectFloorPlanModal.Save',
    defaultMessage: 'Save',
  },
});

export default messages;
